'use client';

import React from 'react';
import { KeyboardDetectionContext, keyboardDetectionContextDefault } from "../../contexts/KeyboardDetectionContext.mjs";
import { useKeyboardDetection } from "../../hooks/useKeyboardDetection.mjs";
var isUsingKeyboardDefault = keyboardDetectionContextDefault.isUsingKeyboard;
export var KeyboardDetectionProvider = function KeyboardDetectionProvider(props) {
  var _useKeyboardDetection = useKeyboardDetection(isUsingKeyboardDefault),
    isUsingKeyboard = _useKeyboardDetection.isUsingKeyboard;
  return /*#__PURE__*/React.createElement(KeyboardDetectionContext.Provider, {
    value: {
      isUsingKeyboard: isUsingKeyboard
    }
  }, props.children);
};